import { useDevice } from '@composable/useDevice';

export function useViewPortBottom() {
    const size = ref('0');
    const { isWebApp } = useDevice();

    const listener = () => {
        if (!isWebApp.value) {
            size.value = `${window.innerHeight - (window.visualViewport?.height ?? 0)}px`;
        } else {
            size.value = '0';
        }
    };

    onMounted(() => {
        if (typeof window !== 'undefined') {
            window.visualViewport?.addEventListener('resize', listener);
        }
    });

    onUnmounted(() => {
        if (typeof window !== 'undefined') {
            window.visualViewport?.removeEventListener('resize', listener);
        }
    });

    return size;
}
